import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { useAuth } from '@/contexts/AuthContext';
import { abaEmBreve, getSiPortalTabHref } from '../siPortal.definitions';
import { useSiPortalTabs } from '../hooks/useSiPortalTabs';

/** Mesmo visual da barra do Portal do DP (DpPortalTabNav): abas em pílula, a ativa vem da URL. */
export function SiPortalTabNav() {
  const tabs = useSiPortalTabs();
  const { userHasRole } = useAuth();

  return (
    <nav
      aria-label="Seções do Portal do SI"
      data-tour="si-abas"
      className="min-w-0 max-w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      <ul className="flex w-max gap-1 rounded-full border border-primary-100 bg-white p-1 shadow-sm">
        {tabs.map((tab) => (
          <li key={tab.id}>
            {abaEmBreve(tab, { hasRole: userHasRole }) ? (
              <span
                aria-disabled="true"
                title="Em breve"
                className="inline-flex cursor-not-allowed items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 font-montserrat text-sm font-medium text-raro-gray-400"
              >
                {tab.icone && <span aria-hidden="true">{tab.icone}</span>}
                {tab.label}
                <span className="rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">Em breve</span>
              </span>
            ) : (
            <NavLink
              to={getSiPortalTabHref(tab)}
              className={({ isActive }) =>
                clsx(
                  'inline-flex items-center whitespace-nowrap rounded-full px-4 py-2 text-sm font-montserrat transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
                  isActive
                    ? 'bg-primary-600 font-semibold text-white shadow-sm'
                    : 'font-medium text-raro-gray-600 hover:bg-primary-50 hover:text-primary-700'
                )
              }
            >
              {tab.icone && <span aria-hidden="true">{tab.icone} </span>}
              {tab.label}
            </NavLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
